module.exports = __webpack_public_path__ + "static/media/lock-feature-01.de57c60c.png";